import { useLaunchDarkly } from "~/composables/useLaunchDarkly";
import { useUpNavigationStore } from "~/store/upNavigationStore.ts";
import { useUserStore } from "~/store/user.ts";
import { useLoadingStore } from "@/store/loading";

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return;

  const loadingStore = useLoadingStore();
  const taskId = `upNavigation-middleware-${Date.now()}`;
  loadingStore.startTask(taskId);

  const userStore = useUserStore();
  const upNavigationStore = useUpNavigationStore();
  const ld = await useLaunchDarkly();
  const { isUpNavFlagReady, upNavFlag, isNewAnalyticsFlagReady } =
    storeToRefs(upNavigationStore);
  const {
    fetchUpNavFlag,
    fetchNewAnalyticsFlag,
    handleRouteRedirections,
    setInitialNavigationState,
  } = upNavigationStore;

  if (!isUpNavFlagReady.value) {
    await fetchUpNavFlag();
  }

  if (!upNavFlag.value) {
    loadingStore.endTask(taskId);
    return;
  }

  if (!isNewAnalyticsFlagReady.value) {
    await fetchNewAnalyticsFlag();
  }

  await userStore.fetchUserApplications();

  let showNewPPTReportsFlag = false;
  if (!ld.isLDClient()) {
    showNewPPTReportsFlag = await ld.getFlagValue("showNewPPTReports");
  }

  let routePath = to.fullPath.includes("?")
    ? to.fullPath.substring(0, to.fullPath.indexOf("?"))
    : to.fullPath;

  // Handle edge cases
  if (to.fullPath.includes("graph=articles")) {
    routePath = `${routePath}?graph=articles`;
  } else if (to.fullPath.includes("graph=topics")) {
    routePath = `${routePath}?graph=topics`;
  } else if (to.fullPath.includes("/ppt-reports") && !showNewPPTReportsFlag) {
    // TODO: Remove this check once we fully migrate to the new PPT Reports
    loadingStore.endTask(taskId);
    return navigateTo("/search");
  }

  // Handle redirections if any
  const redirectionResponse = handleRouteRedirections(routePath);
  if (redirectionResponse) {
    loadingStore.endTask(taskId);
    return redirectionResponse;
  }
  // Set Initial Navigation State
  setInitialNavigationState(routePath);

  // This block handles the edge case where we hit the non reports pages
  if (!routePath.includes("/reports")) {
    document.getElementById("cm-reports-app")?.remove();
  }

  loadingStore.endTask(taskId);
});
